export default __webpack_public_path__ + "static/media/stackRunway.2f25a20b.jpg";